import { FC } from "react";
import { Space, Stack, Text, Textarea } from "@mantine/core";

interface AddCommentsFormComponentProps {
  note: string;
  setNote: (e: any) => void;
  placeholderText: string;
}
export const AddCommentsFormComponent: FC<AddCommentsFormComponentProps> = ({
  note,
  setNote,
  placeholderText,
}) => {
  return (
    <Stack gap={8}>
      <Space h="4" />
      <Text fz="xs" fw="700">
        Comments
      </Text>
      <Textarea
        placeholder={placeholderText}
        fz="xs"
        data-autofocus
        data-testid="NoteInput"
        autosize
        minRows={1}
        maxRows={20}
        value={note}
        onChange={(e) => setNote(e.currentTarget.value)}
        styles={{ input: { fontSize: 12 } }}
      />
    </Stack>
  );
};
